import './refer-a-friend-view.scss';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchMyReferrals,
  sendReferral,
} from '../../../actions/referralActions';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import MyReferralsList from './components/MyReferralsList/MyReferralsList';
import ReferralTerms from './components/ReferralTerms/ReferralTerms';
import SendInvitationForm from './components/SendInvitationForm/SendInvitationForm';

function ReferAFriendView() {
  const dispatch = useDispatch();
  const {
    referrals,
    isLoading,
    sendingInvitation,
    invitationStatusMessage,
    error,
  } = useSelector((state) => state.referral);

  useEffect(() => {
    dispatch(fetchMyReferrals());
  }, [dispatch]);

  const handleSendInvitation = (email) => {
    dispatch(sendReferral(email));
  };

  const messageType = error
    ? 'error'
    : invitationStatusMessage
      ? 'success'
      : '';
  const statusMessage = error || invitationStatusMessage || '';

  return (
    <main className="refer-a-friend-container">
      {isLoading && referrals.length === 0 ? (
        <div className="loading-container">
          <CircularLoading className="loading-gif-waiting" />
        </div>
      ) : (
        <div className="refer-a-friend-content mt-4">
          <div className="refer-a-friend-top-section">
            <MyReferralsList
              referrals={referrals}
              isLoading={isLoading}
              className="refer-a-friend-top-section-item"
            />
            <SendInvitationForm
              onSendInvitation={handleSendInvitation}
              isLoading={sendingInvitation}
              statusMessage={statusMessage}
              messageType={messageType}
              className="refer-a-friend-top-section-item"
            />
          </div>
          <ReferralTerms />
        </div>
      )}
    </main>
  );
}

export default ReferAFriendView;
